module.exports = __webpack_public_path__ + "static/media/wn_3close upIMG_3494.603d9381.jpg";